import { render, staticRenderFns } from "./EduLevelCell.vue?vue&type=template&id=3cd265bc&"
import script from "./EduLevelCell.vue?vue&type=script&lang=ts&"
export * from "./EduLevelCell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports